import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Userlist from "../../../Component/List/userlist";
import Welcomeapi from "./welcomeapi";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#f8f8f6",
    height: "100vh",
    paddingTop: "0.5rem",
  },
  leftContent: {
    height: `calc(100vh - 8.1rem)`,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: "#FFFFFF",
    overflowY: "auto",
    boxShadow: "1px 1px 2px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 2px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 2px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "flex",
    },
  },
  rightContent: {
    height: "calc(100vh - 8rem)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f8f6",
    overflowY: "auto",
  },
  upperContent: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    height: "auto",
    display: "flex",
    lignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #7c7c7c",
  },
}));

const Apiconsole = ({ children }) => {
  const [role] = useState(
    localStorage.getItem("role") === "admin"
      ? "Administrator"
      : localStorage.getItem("role") === "root"
      ? "Administrator"
      : "Contact User"
  );
  //const [role, setRole] = useState("Administrator");
  const [open, setopen] = useState(false);
  const [choice, setChoice] = useState(role === "Administrator" ? 0 : null);
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item lg={2} md={12} sm={12} xs={12}>
          <div className={classes.leftContent}>
            <Userlist
              choice={choice}
              setChoice={setChoice}
              role={role}
              open={open}
              setopen={setopen}
            />
          </div>
        </Grid>
        <Grid item lg={10} md={12} sm={12} xs={12}>
          <div className={classes.rightContent}>
            {children !== undefined ? children : <Welcomeapi />}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Apiconsole;
